import React from 'react';

import { keyframes } from '@emotion/react';
import { Box, Stack, Typography } from '@mui/material';

import { GENERATING_BADGE_LABEL } from '../../lib/constants';

/** Sweeps a brighter band across the neutral text (переливание). */
const shimmer = keyframes`
  0% { background-position: 200% center; }
  100% { background-position: -200% center; }
`;

/** Fades a single dot in and out; staggered per dot to read as a wave. */
const dotPulse = keyframes`
  0%, 80%, 100% { opacity: 0.2; }
  40% { opacity: 1; }
`;

// Tweak these to retune the animation feel.
const SHIMMER_DURATION = '2.6s';
const DOT_DURATION = '1.4s';
const DOT_DELAYS = [0, 0.2, 0.4];

export const GettingReadyBadge: React.FC = () => (
  <Stack
    sx={{
      backgroundColor: 'common.white',
      border: '1px solid',
      borderColor: 'grey.300',
      borderRadius: 120,
      px: 9,
      py: 2,
    }}
    alignItems="center"
    direction="row"
    gap={4}
  >
    <Typography
      sx={(theme) => ({
        '@media (prefers-reduced-motion: reduce)': {
          animation: 'none',
          color: theme.palette.grey[700],
          WebkitTextFillColor: theme.palette.grey[700],
        },
        animation: `${shimmer} ${SHIMMER_DURATION} linear infinite`,
        background: `linear-gradient(90deg, ${theme.palette.grey[700]} 0%, ${theme.palette.grey[400]} 50%, ${theme.palette.grey[700]} 100%)`,
        backgroundClip: 'text',
        backgroundSize: '200% auto',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      })}
      variant="body-2-md"
    >
      {GENERATING_BADGE_LABEL}
    </Typography>

    <Stack
      alignItems="center"
      alignSelf="flex-end"
      data-testid="getting-ready-dots"
      direction="row"
      gap={3}
      marginBottom={4}
    >
      {DOT_DELAYS.map((delay) => (
        <Box
          key={delay}
          sx={{
            '@media (prefers-reduced-motion: reduce)': {
              animation: 'none',
              opacity: 1,
            },
            animation: `${dotPulse} ${DOT_DURATION} ease-in-out ${delay}s infinite`,
            backgroundColor: 'grey.600',
            borderRadius: '50%',
            height: 3,
            width: 3,
          }}
          aria-hidden
        />
      ))}
    </Stack>
  </Stack>
);
